const EVENT_FIELD = 'event';
const STATUS_FIELD = 'status';
const TIMESTAMP_FIELD = 'timestamp';
const ID_FIELD = 'id';
const OS_WINDOWS = 'Windows';

export default {
  EVENT_FIELD,
  STATUS_FIELD,
  TIMESTAMP_FIELD,
  ID_FIELD,
  OS_WINDOWS,
};
